import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';
import image1 from '../../assets/images/slide-image-1.jpg';
import image2 from '../../assets/images/slide-image-2.jpg';
import image3 from '../../assets/images/slide-image-3.jpg';

const intitialState = {
  // domain: 'http://new-okapi.ddev.site/',
  domain: 'http://www.okapimadrededia.es/',
  nameSlogan: {
    name: 'Okapi',
    slogan: 'Casa Nido en Oviedo'
  },
  text: null,
  menu: [],
  images: [],
  isHome: true,
  node: {
    title: null,
    text: null,
    image: null
  },
  list: [],
  lastList: [],
  interestingLinks: null,
  allPosts: []
};

const getDomain = (state, actions) => {
  const updatedState = {
    domain: state.domain
  };
  return updateObject(state, updatedState);
}

const getName = (state, actions) => {
  const updatedState = {
    nameSlogan: state.nameSlogan
  };
  return updateObject(state, updatedState);
}

const getPreface = (state, actions) => {
  const updatedState = {
    text: actions.text
  };
  return updateObject(state, updatedState);
}

const getMenu = (state, actions) => {
  const updatedState = {
    menu: actions.menu
  };
  return updateObject(state, updatedState);
}

const getCarousel = (state, actions) => {
  const imagesCarousel = [
    { image: image1, alt: 'Okapi', text: '...en Okapi nos mimamos...' },
    { image: image2, alt: 'Elefante', text: '...somos leeeeeeeentos...' },
    { image: image3, alt: 'Estrella', text: '...y soñamos...' },
  ];
  const updatedState = {
    images: imagesCarousel
  };
  return updateObject(state, updatedState);
}

const getPage = (state, actions) => {
  const node = {
    title: actions.node.title,
    text: actions.node.body,
    image: actions.node.field_image,
  };
  const updatedState = {
    node: node
  };
  return updateObject(state, updatedState);
}

const getPostList = (state, actions) => {
  const updatedState = {
    list: actions.list
  };
  return updateObject(state, updatedState);
}

const getLastPostList = (state, actions) => {
  const updatedState = {
    lastList: actions.lastList
  };
  return updateObject(state, updatedState);
}

const getInterestingLinks = (state, actions) => {
  const updatedState = {
    interestingLinks: actions.interestingLinks
  };
  return updateObject(state, updatedState);
}

const getAllPosts = (state, actions) => {
  const updatedState = {
    allPosts: actions.allPosts
  };
  return updateObject(state, updatedState);
}

const inHome = (state, actions) => {
  return updateObject(state, {isHome: true});
}

const noHome = (state, actions) => {
  return updateObject(state, {isHome: false});
}

const reducer = (state = intitialState, actions) => {
  switch (actions.type) {
    case actionTypes.GET_DOMAIN: return getDomain(state, actions);
    case actionTypes.GET_NAME: return getName(state, actions);
    case actionTypes.GET_PREFACE: return getPreface(state, actions);
    case actionTypes.GET_MENU: return getMenu(state, actions);
    case actionTypes.GET_CAROUSEL: return getCarousel(state, actions);
    case actionTypes.GET_PAGE: return getPage(state, actions);
    case actionTypes.GET_LIST_POSTS: return getPostList(state, actions);
    case actionTypes.GET_LAST_LIST_POSTS: return getLastPostList(state, actions);
    case actionTypes.GET_INTERESTING_LINKS: return getInterestingLinks(state, actions);
    case actionTypes.GET_ALL_POSTS: return getAllPosts(state, actions);
    case actionTypes.IN_HOME: return inHome(state, actions);
    case actionTypes.NO_HOME: return noHome(state, actions);
    default: return state;
  }
};

export default reducer;
